import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { COLORS } from "../common/style";

const NavbarContainer = styled.div`
  width: 100%;
  height: 3.2em;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${COLORS.mainThemeColor};
  font-family: Oxygen, sans-serif;
  padding: 15px 3em;
  z-index: 99;
`;

const NavbarAnchor = styled.div`
  & > a {
    width: 3em;
    height: fit-content;
    font-size: 18px;
    color: #fff;
    transition: color, 120ms ease-in-out;
    cursor: pointer;
    margin-right: 24px;
    text-decoration: none;
    &:hover {
      color: #ddd;
    }
  }
`;

const Header = ({ siteTitle }) => (
  <NavbarContainer>
    <NavbarAnchor>
      <Link to="/">Home</Link>
    </NavbarAnchor>
    <NavbarAnchor>
      <Link to="/docs/">Docs</Link>
    </NavbarAnchor>
    <NavbarAnchor>
      <Link to="/about/">About</Link>
    </NavbarAnchor>
    <NavbarAnchor>
      <Link to="/demo/">Demo</Link>
    </NavbarAnchor>
  </NavbarContainer>
);

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
